import { gql } from 'apollo-angular';

export const RemoveResourceTeamDocument = gql`
  mutation removeResourceTeam($id: Int!) {
    removeResourceTeam(id: $id)
  }
`;
